module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-BoldItalic.0755313.ttf";